module.exports = __webpack_public_path__ + "static/media/delivery-man.ba484ac0.svg";